export const FETCH_SITE_LIST_SUCCESS = "AGENTCONNECT_SITE_LIST_SUCCESS"
export const FETCH_SITE_LIST_FAILURE = "AGENTCONNECT_SITE_LIST_FAILURE"
export const SHOW_PAGINATION_PROGRESS = "AGENTCONNECT_SHOW_PAGINATION_PROGRESS";
export const CREATE_AGENT_SITE_SUCCESS = "CREATE_AGENT_SITE_SUCCESS";
export const CREATE_AGENT_SITE_FAILURE = "CREATE_AGENT_SITE_FAILURE";
export const DELETE_AGENT_SITE_PROGRESS = "DELETE_AGENT_SITE_PROGRESS";
export const DELETE_AGENT_SITE_SUCCESS = "DELETE_AGENT_SITE_SUCCESS";
export const DELETE_AGENT_SITE_FAILURE = "DELETE_AGENT_SITE_FAILURE";
export const VALIDATE_SITEID = "VALIDATE_SITEID";
